import React from 'react';
import ArrayKana from '@js/modules/bankAccount/kana.json';
import { UseFormRegister } from 'react-hook-form';
import { BankAccountFormData } from '@js/interfaces';

type Props = {
  register: UseFormRegister<BankAccountFormData>
  fieldLabel: 'bank' | 'branch'
};

export const KanaTable = (props: Props) => {
  const {register, fieldLabel} = props;
  return (
    <div className="kana-table">
      <ul className="kana-table__list">
        {ArrayKana.map((item, index) => {
          return (
            <li
              className={index === 35 || index === 36 ? 'kana-table__item is-blank' : 'kana-table__item'}
              key={item.id}
            >
              <label className="kana-table__radio" htmlFor={`kana-table_${item.id}`}>
                <input
                  {...register(`kana_table_${fieldLabel}`, { required: '頭文字を入力してください' })}
                  type="radio"
                  id={`kana-table_${item.id}`}
                  value={item.kana}
                  className="kana-table__input"
                />
                <span className="kana-table__radio-label">{item.kana}</span>
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
